<!DOCTYPE html>
@if (route.children.length === 0) {
<app-datatable [identifier]="'log-task-table'" [title]="title" [cols]="cols" [rows]="rows" [isloading]="loading"
  [showcheckboxes]="true" [total]="total" (pageevent)="onPageChange($event)" [showaddicon]="true"
  (onclickheaderadd)="addLogsTask()" (actionmenuevent)="actionMenuClicked($event)" [isSortable]="false"></app-datatable>
@if (route.children.length > 0) {
<div class="ot-row">
  <div class="otsc-prop-header">
    <h1 class="otsc-prop-header-text" i18n>Support</h1>
    <div class="ot-btn-group otsc-prop-header-btn">
    </div>
  </div>
</div>
}
@if (route.children.length > 0) {
<div class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-1" style="height: calc(100vh - 150px);">
  <ng-scrollbar #scrollbarRef>
    <div>
      <div id="otsc-settings-suport">
        <div class="ot-form-control ot-form-control--is-horizontal ot-mb-0">
          <div class="ot-form-control__label" i18n>
            Package logs
          </div>
          <button id="otsc-settings-support-logs-btn" role="button" class="ot-btn ot-btn--is-primary"
            (click)="packageLogs()" [disabled]="!packagingLogs" i18n>
            Package
          </button>
        </div>
        <div class="ot-form-control">
          <p id="otsc-settings-support-logs-text" class="ot-form-control__info-text" i18n>
            Package all of the System Center manager and agent logs to give to OpenText support.
          </p>
        </div>
      </div>
    </div>
  </ng-scrollbar>
</div>
}
}
<router-outlet></router-outlet>